import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getCarousels } from "../api";
import { carouselKeys } from "./keys";
import type { CarouselListResponse, PaginationState } from "../../types";

// Home-page carousel slides — server-paginated.
// Returns the raw response body: { data: CarouselItem[], totalItems, ... }
export const useCarouselsQuery = (params: PaginationState) =>
  useQuery<CarouselListResponse>({
    queryKey: carouselKeys.list(params),
    queryFn: async () => {
      const { data } = await getCarousels(params.page, params.size);
      return data;
    },
    enabled: !!params,
    ...reactQueryCacheAndRefetchOptions,
  });
